import styled, { css } from 'styled-components'

import { snakeSettings } from './snakeSettings'

export const ScrollNotification = styled.div`
  margin-top: 10px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.5);
  align-self: center;
`

export const SnakeWrapper = styled.div`
  ${({ isMini, themeType }) => css`
    position: relative;

    ${isMini &&
    css`
      display: grid;
      justify-content: center;
      max-height: ${snakeSettings[themeType].mini.cacheMaxHeight}px;
      overflow: auto;
    `}

    canvas {
      display: block;
    }
  `}
`

export const TimelineInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 6px 18px;
  margin: 10px 4px 0;
  font-size: 13px;
  color: ${({ themeType }) => (themeType === 'dark' ? 'rgba(255, 255, 255, 0.78)' : 'rgba(15, 55, 68, 0.78)')};
`

export const TimelineTooltip = styled.div`
  position: absolute;
  z-index: 5;
  pointer-events: none;
  transform: translate(-50%, calc(-100% - 8px));
  padding: 5px 8px;
  border-radius: 6px;
  white-space: nowrap;
  font: 12px monospace;
  color: ${({ themeType }) => (themeType === 'dark' ? '#071015' : '#fff')};
  background: ${({ themeType }) => (themeType === 'dark' ? '#ffd60a' : '#0f7489')};
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.22);
`
